import { PopoverFactory } from '@/components/common/popover'

/**
 * hoverOverMessage [String] this is required to have a message in the hover
 * hasHoverOverMessage [Boolean] this is used to make sure that we can have a hover over
 */
export default {
  methods: {
    showUEHoverOver (e) {
      if (!this.hoverOverPopover && this.hasHoverOverMessage) {
        this.hoverOverPopover = PopoverFactory.createListBoxWithHoverOver({
          direction: 'top',
          list: [{value: true, name: `Path: ${this.attribute.dataset} / ${this.attribute.path} /`}, {value: true, name: this.hoverOverMessage}],
          parent: e.currentTarget,
          hoverOver: this.$el
        })
        this.popover = this.hoverOverPopover
      }
    },
    hideUEHoverOver (e) {
      if (this.hoverOverPopover) {
        this.hoverOverPopover = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/components/mixins/HoverOver.js